import { computed, Ref } from 'vue'
import type { MultiselectOption } from '@ironsight/types'
import { useInventoryTypes } from '@/composables/inventory-types/useInventoryTypes'

export function useInventorySubTypeFilter(): {
  options: Ref<MultiselectOption[]>
} {
  const { allInventoryTypes } = useInventoryTypes()

  const options = computed<MultiselectOption[]>(() => {
    const subsById: Map<number, MultiselectOption> = new Map()
    for (const inv of allInventoryTypes.value ?? []) {
      for (const cond of inv.inventorySubTypes) {
        if (cond.id != null && !subsById.has(cond.id)) {
          subsById.set(cond.id, {
            label: `${inv.name} · ${cond.name}`.trim(),
            value: cond.id,
          })
        }
      }
    }
    return Array.from(subsById.values()).sort((a, b) => a.label.localeCompare(b.label))
  })

  return { options }
}
